module.exports = __webpack_public_path__ + "static/media/netfit_back_12.995cdf08.jpg";